// extracted by mini-css-extract-plugin
module.exports = {"header":"ContractOverviewTab_header__1mzLh","headerWrapper":"ContractOverviewTab_headerWrapper__19Ea6"};